var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaverSolution2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.706 59.2912C50.0279 62.0183 47.0157 63.8365 43.5788 63.8365C41.8425 63.8365 40.2146 63.3725 38.8124 62.5616C37.4101 63.3725 35.7822 63.8365 34.0459 63.8365C29.2916 63.8365 25.3499 60.3571 24.6283 55.8058C24.5891 55.8062 24.5498 55.8064 24.5104 55.8064C18.4123 55.8064 13.4688 50.8629 13.4688 44.7648C13.4688 42.7537 14.0064 40.8681 14.9459 39.244C14.0064 37.62 13.4688 35.7344 13.4688 33.7233C13.4688 27.6252 18.4122 22.6818 24.5102 22.6817L24.5102 22.6718H25.0386C29.44 22.6718 33.0499 26.0604 33.4018 30.371L27.3194 46.2362C26.957 47.1814 27.4295 48.2414 28.3747 48.6038C29.3199 48.9661 30.3799 48.4937 30.7423 47.5485L32.1235 43.9459L38.8206 43.9455L40.2019 47.5485C40.5643 48.4937 41.6243 48.9661 42.5695 48.6038C43.5147 48.2414 43.9872 47.1814 43.6248 46.2362L37.1836 29.435C37.1165 29.2601 37.0245 29.0998 36.9126 28.9576C35.9281 23.3677 31.0927 19.1052 25.2437 19.0077C26.6823 15.5651 30.0816 13.146 34.0459 13.146C35.7822 13.146 37.4101 13.6101 38.8124 14.4209C40.2146 13.6101 41.8425 13.146 43.5788 13.146C48.8452 13.146 53.1145 17.4153 53.1145 22.6817C59.2126 22.6818 64.156 27.6252 64.156 33.7233C64.156 35.7344 63.6183 37.62 62.6789 39.244C63.6183 40.8681 64.156 42.7537 64.156 44.7648C64.156 50.8629 59.2125 55.8064 53.1143 55.8064L53.0678 55.8063L53.0416 55.8061C50.4456 55.4921 48.4341 53.2811 48.4341 50.6004V46.9596C48.4349 46.9372 48.4353 46.9146 48.4353 46.8919L48.4353 30.0962C48.4353 29.0839 47.6147 28.2633 46.6024 28.2633C45.5901 28.2633 44.7695 29.0839 44.7695 30.0962L44.7695 45.3815H44.7683V50.6004C44.7683 54.8435 47.7342 58.3938 51.706 59.2912ZM37.4152 40.2798L35.4721 35.2114L33.5289 40.28L37.4152 40.2798Z",
    fill: "url(#paint0_linear_2137_19400)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_19400",
    x1: 38.8125,
    y1: 13.146,
    x2: 7.06941,
    y2: 60.9934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#233845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49B492"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaverSolution2);
export default __webpack_public_path__ + "static/media/naverSolution2.23bd63e3c1d6e7be48427462338a12d2.svg";
export { ForwardRef as ReactComponent };